import "./styles.css";
import { Game, type GameDebugApi } from "./game/Game";

declare global {
  interface Window {
    __INFERNAL_BREACH__?: GameDebugApi;
  }
}

const root = document.querySelector<HTMLElement>("#app");
if (!root) {
  throw new Error("Application root #app is missing");
}

try {
  const game = new Game(root);
  if (import.meta.env.DEV) window.__INFERNAL_BREACH__ = game.debugApi;
} catch (error) {
  console.error("Unable to initialize game", error);
  const screen = document.createElement("section");
  screen.className = "screen loading-screen";
  screen.setAttribute("role", "alert");
  const title = document.createElement("h2");
  title.textContent = "НЕ УДАЛОСЬ ЗАПУСТИТЬ ГРАФИКУ";
  const message = document.createElement("p");
  message.textContent =
    "Проверьте поддержку WebGL и аппаратное ускорение браузера. Закройте лишние вкладки и повторите запуск.";
  const retry = document.createElement("button");
  retry.textContent = "ПОВТОРИТЬ";
  retry.addEventListener("click", () => location.reload());
  screen.append(title, message, retry);
  root.replaceChildren(screen);
}
